export const encodeComponentName = (name, separator = '_') => {
  return name.replace(/ /g, separator).toLowerCase();
};
export const encodeNavigation = name => {
  return '/' + encodeComponentName(name, '-');
};
export const encodeComponentPaths = paths => {
  return paths && paths.length > 0 && paths.filter((e, i) => i > 0).length > 0 && paths.filter((e, i) => i > 0).map(c => {
    return encodeComponentName(c.title);
  }).join('/');
};
export const getFileName = path => {
  const nameWithExtension = path.split('/')[path.split('/').length - 1];
  return nameWithExtension;
};
export const getFileExtension = path => {
  return path.split('.')[path.split('.').length - 1];
};
export const updateHomepageTilesTemplate = configurationTiles => {
  const tiles = [...configurationTiles];
  const selectedTiles = tiles.length;
  tiles.forEach(tile => {
    tile.dimension = 1;
  });
  switch (selectedTiles) {
    case 4:
      tiles.forEach(tile => {
        tile.dimension = 1.5;
      });
      break;
    case 5:
      tiles.forEach(tile => {
        tile.dimension = 1.5;
      });
      tiles[4].dimension = 3;
      break;
    case 6:
      tiles.forEach(tile => {
        tile.dimension = 1.5;
      });
      break;
    case 7:
      tiles[6].dimension = 3;
      break;
    case 8:
      tiles.forEach(tile => {
        tile.dimension = 1.5;
      });
      break;
    case 10:
      tiles[9].dimension = 3;
      break;
    case 11:
      tiles[10].dimension = 2;
      break;
    default:
      break;
  }
  return tiles;
};
export default {
  encodeComponentName,
  encodeNavigation,
  getFileName,
  getFileExtension,
  updateHomepageTilesTemplate
};